import queryString from 'query-string';
import { EnvConfig } from '../../config/envconfig';

const defaultConfig = {
    automaticSilentRenew: false, //(boolean, default: false): Flag to indicate if there should be an automatic attempt to renew the access token prior to its expiration.
    loadUserInfo: false, //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
    audience: 'https://example.com', //is there a way to specific the audience when making the jwt
    response_type: 'id_token token', //(string, default: 'id_token'): The type of response desired from the OIDC provider.
    scope: 'sds openid', //(string, default: 'openid'): The scope being requested from the OIDC provider.
    webAuthResponseType: 'id_token token'
};

export const redirectUrl = (
    config: Record<string, unknown>,
    authUrl: string | undefined
) => {
    const configQueryString = queryString.stringify(config);
    return `${authUrl}?${configQueryString}`;
};

export const redirectIdentityServer = (config: EnvConfig, force = false) => {
    const queryParams: Record<string, unknown> = {
        client_id: config.client_id,
        redirect_uri: config.redirect_uri,
        response_type: 'id_token token',
        scope: 'sds openid',
        nonce: `${Date.now()}${Math.random()}`,
        state: `${Date.now()}${Math.random()}`,
        prompt: force == true ? 'login' : undefined,
        guest: config.guestUserSupported == true ? true : undefined
    };

    window.location.href = redirectUrl(queryParams, config.authUrl);
};

export const getAuthConfiguration = (runTimeConfig: EnvConfig) => {
    const config = { ...defaultConfig, ...runTimeConfig };
    return {
        client_id: config.client_id,
        redirect_uri: config.redirect_uri,
        response_type: config.response_type,
        scope: config.scope,
        nonce: `${Date.now()}${Math.random()}`,
        state: `${Date.now()}${Math.random()}`
    };
};

export const signOutUrl = (
    id_token_hint: string | undefined,
    config: EnvConfig
) => {
    const redirectConfig = {
        id_token_hint,
        post_logout_redirect_uri: config.post_logout_redirect_uri
    };

    return redirectUrl(redirectConfig, config.logoutUrl);
};

export const signInUrl = (config: EnvConfig) => {
    const authConfig = getAuthConfiguration(config);
    const authurl2 = config.authUrl;
    return redirectUrl(authConfig, authurl2);
};
